import _ from 'lodash';

export const SET_REFERRAL_NAME = (state, action) => ({
  ...state,
  forms: {  
    ...state.forms,
    modal: {
      ...state.forms.modal,
      name: {
        ...state.forms.modal.name,
        value: action.payload.nameValue
      }
    }
  }
})

export const SET_REFERRAL_DESCRIPTION = (state, action) => ({
  ...state,
  forms: {  
    ...state.forms,
    modal: {
      ...state.forms.modal,
      description: {
        ...state.forms.modal.description,
        value: action.payload.descriptionValue
      }
    }
  }
})

export const RESET_REFERRAL_FORM = (state, action) => ({
  ...state,
  forms: {  
    ...state.forms,
    modal: {
      ...state.forms.modal,
      name: {
        ...state.forms.modal.name,
        value: '',
        error: false
      },
      description: {
        ...state.forms.modal.description,
        value: '',
        error: false
      }
    }
  }
})

export const PUSH_NEW_REFERRAL_TO_LIST = (state, action) => ({
  ...state,
  api: {
    ...state.api,
    referralList: [
      ...state.api.referralList,
      { ...action.payload }
    ]
  }
})

export const UPDATE_ITEM_ON_LIST = (state, action) => ({
  ...state,
  api: {
    ...state.api,
    referralList: _.map([ ...state.api.referralList ], listItem => {
      if(listItem.id !== action.payload.id ) return listItem
      return action.payload;
    }) 
  }
})

export const LIST_REFERRALS_FETCH_REQUEST = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    listReferralModel: true
  }
})

export const LIST_REFERRALS_FETCH_ERROR = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    listReferralModel: false
  }
})

export const LIST_REFERRALS_FETCH_SUCCESS = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    listReferralModel: false
  },
  api: {
    ...state.api,
    referralList: [ ...action.payload.list ]
  }
})

export const CREATE_REFERRAL_FETCH_REQUEST = (state, action) => ({ 
  ...state,
  fetching: {
    ...state.fetching,
    createReferralModel: true
  }
})

export const CREATE_REFERRAL_FETCH_ERROR = (state, action) => ({
  ...state, 
  fetching: {
    ...state.fetching,
    createReferralModel: false
  }
})

export const CREATE_REFERRAL_FETCH_SUCCESS = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    createReferralModel: false
  } 
})

export const UPDATE_REFERRAL_FETCH_REQUEST = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    updateReferralModel: true
  }
})

export const UPDATE_REFERRAL_FETCH_ERROR = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    updateReferralModel: false
  }
})

export const UPDATE_REFERRAL_FETCH_SUCCESS = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    updateReferralModel: false
  }
})

export const GET_REFERRAL_FETCH_REQUEST = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    getReferralModel: true
  }
})

export const GET_REFERRAL_FETCH_ERROR = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    getReferralModel: false
  }
})

export const GET_REFERRAL_FETCH_SUCCESS = (state, action) => ({
  ...state,
  fetching: {
    ...state.fetching,
    getReferralModel: false
  },
  api: {
    ...state.api,
    referralModel: { ...action.payload }
  }
})